import React, {FC, Fragment} from "react"
import {TextModel} from "models/Text"
import {FiltersPanelContainer} from "../components"
import FilterSearchBar from "../tabbedFilterSearch"
import TabbedFilter from "../tabbedFilter"
import {TabbedFilterContainer, AlphabetSection, PromotedBrandsContainer} from "../tabbedFiltersPanel/components"
import connect from "./connect"
import {sortFacetAlphabatically} from "../../../utils/sortFacetsAlphabatically"

interface Props {
    setFreeTextFilterSearch: (e: React.SyntheticEvent, filterName: string) => void
    clearFreeTextSearchForFilter: (filterName: string) => void
    filterFacets: {
        filteredFacetsOfTopFive: string[]
        restOfFilteredFacets: string[]
    }
    freeTextFilterSearch: {[key: string]: string}
    text: TextModel
    filterName: string
    filterDisplayName: string
    freeTextFiltersList: string[]
    compositeFiltersList: string[]
}

export const AlphabeticallySortedTabbedFilter: FC<Props> = ({
    filterFacets,
    setFreeTextFilterSearch,
    freeTextFilterSearch,
    text,
    filterName,
    filterDisplayName,
    clearFreeTextSearchForFilter,
    freeTextFiltersList,
    compositeFiltersList,
}) => {
    const alphabeticalOrderFilters = sortFacetAlphabatically(filterFacets.restOfFilteredFacets)

    return (
        <FiltersPanelContainer data-testid="plp-tabbed-filters-panel-brand">
            {(freeTextFiltersList.includes(filterName) || compositeFiltersList.includes(filterName)) && (
                <FilterSearchBar
                    setFreeTextFilterSearch={e => setFreeTextFilterSearch(e, filterName)}
                    clearFreeTextSearchForFilter={() => {
                        clearFreeTextSearchForFilter(filterName)
                    }}
                    freeTextFilterSearch={freeTextFilterSearch}
                    filterName={filterName}
                    text={text}
                    filterDisplayName={filterDisplayName}
                />
            )}
            <PromotedBrandsContainer data-testid="plp-tabbed-facets-panel-promoted-brands">
                {filterFacets.filteredFacetsOfTopFive.length > 0 && (
                    <>
                        <AlphabetSection data-testid="plp-horizontal-filters-brand-alphabet-title-promoted">
                            {`${text.pages.filters.popularText} ${filterName}s`}
                        </AlphabetSection>

                        {filterFacets.filteredFacetsOfTopFive.map(filter => (
                            <TabbedFilter
                                key={filter}
                                filterName={filter}
                                isTabbedFilter
                                facetName={filterName}
                                data-testid="plp-tabbed-facets-promoted-brand"
                            />
                        ))}
                    </>
                )}
            </PromotedBrandsContainer>
            <TabbedFilterContainer data-testid="plp-tabbed-facets-other-brands">
                {Object.keys(alphabeticalOrderFilters)
                    .sort()
                    .map(letter => (
                        <Fragment key={letter}>
                            <AlphabetSection data-testid={`plp-tabbed-brand-alphabet-title-${letter}`}>
                                {letter}
                            </AlphabetSection>
                            {alphabeticalOrderFilters[letter].sort().map(filter => (
                                <TabbedFilter key={filter} filterName={filter} facetName={filterName} isTabbedFilter />
                            ))}
                        </Fragment>
                    ))}
            </TabbedFilterContainer>
        </FiltersPanelContainer>
    )
}

export default connect(AlphabeticallySortedTabbedFilter)
